import axios from "axios";
import { GTR_API_BASE_URL, GTR_GEOCODER_KEY } from "../../consts/runtimeConfig";

const api = axios.create({
  baseURL: GTR_API_BASE_URL,
});

const locationApi = axios.create({
  baseURL: "https://api.locationiq.com/v1",
  params: { key: GTR_GEOCODER_KEY },
});

export { api, locationApi };
